export default __webpack_public_path__ + "static/fairhousingnotice-e345500a79c5862b4f3d665d7389b113.pdf";